/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */ // TODO: add props
import { useEffect, useRef } from 'react';
import * as React from 'react';
import { Overlay } from 'react-bootstrap';

// Wraps an element which clicking on triggers the overlay to show.
// The wrapped element must not be a purely functional component
// if precise targeting is required. If it is no, the component
// falls back to targeting a div wrapper around the child.

const UniqueOverlayTrigger = React.forwardRef((props, forwardRef) => {
  const {
    renderOverlay,
    children,
    isShown,
    showOverlay,
    hideOverlay,
    placement,
    forceInitialShow,
    rootClose,
  } = props;

  const localRef = useRef();
  const ref = forwardRef || localRef;
  useEffect(() => {
    if (forceInitialShow) {
      showOverlay();
    }
  }, [forceInitialShow, showOverlay]);

  const toggle = isShown ? hideOverlay : showOverlay;
  const child = React.Children.only(children);
  const handleKeyDown = (event) => {
    // Activate on 'Enter' or 'Space'
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent scrolling for spacebar
      toggle();
    }
  };
  const trigger = React.cloneElement(child, {
    ref,
    onClick: (e) => {
      toggle();
    },
    role: 'button',
    tabIndex: 0,
    onKeyDown: handleKeyDown,
  });

  return (
    <>
      {trigger}
      <Overlay
        placement={placement}
        show={isShown}
        target={() => ref.current || this}
        rootClose={rootClose}
        onHide={hideOverlay}
      >
        {renderOverlay({ hide: hideOverlay })}
      </Overlay>
    </>
  );
});

UniqueOverlayTrigger.defaultProps = {
  onShow: () => {},
  onHide: () => {},
};
export default UniqueOverlayTrigger;
